import { LinearProgress, Paper } from "@material-ui/core";
import React, { useEffect } from "react";
import { Alert } from "../../../../ui";
import { useQueryContext } from "../../context";
import { TableUI } from "./elements";

const QueryTable = () => {
  const { precatorios, quotaUsage, queryStatus } = useQueryContext();

  useEffect(() => {
    if (queryStatus === "loading") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [queryStatus]);

  return (
    <Paper elevation={5}>
      {queryStatus === "loading" ? (
        <div className="q-progress">
          <LinearProgress />
        </div>
      ) : queryStatus === "error" ? (
        <Alert
          centerMessage
          severity="error"
          message="Ocorreu um erro ao processar sua busca. Se o erro persistir, entre em contato conosco."
        />
      ) : null}

      {quotaUsage > 70 && (
        <Alert
          centerMessage
          severity={quotaUsage === 100 ? "error" : "warning"}
          message={`Você já usou ${quotaUsage}% da sua cota. Caso queira contratar mais limite, entre em contato conosco`}
        />
      )}

      {precatorios ? (
        <TableUI />
      ) : queryStatus === "idle" ? (
        <Alert
          className="m-bg-white"
          centerMessage
          severity="info"
          message="Utilize o formulário para realizar sua busca"
        />
      ) : null}
    </Paper>
  );
};

export default QueryTable;
